import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { PRODUCT_IMAGE } from "./data/product";
const PAGE_TITLE = "Halloween PE Ready™ — Your Halloween PE Week Is Already Planned";
const PAGE_DESCRIPTION = "25 ready-to-run Halloween PE games, 10 visual stations, 8 complete lesson plans and printable resources for elementary and middle school PE teachers. 100% digital, instant access — $19.";
function setMeta(attr: "name" | "property", key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}
function addLink(rel: string, href: string, extra: Record<string, string> = {}) {
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  Object.entries(extra).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
  return link;
}

// SEO basics
document.documentElement.lang = "en";
document.title = PAGE_TITLE;
setMeta("name", "description", PAGE_DESCRIPTION);
setMeta("name", "viewport", "width=device-width, initial-scale=1");
setMeta("name", "robots", "index, follow");
setMeta("name", "theme-color", "#0E1220");
setMeta("property", "og:type", "product");
setMeta("property", "og:title", PAGE_TITLE);
setMeta("property", "og:description", PAGE_DESCRIPTION);
setMeta("property", "og:image", PRODUCT_IMAGE);
setMeta("name", "twitter:card", "summary_large_image");

// Start fetching the hero image (largest element) as early as possible
addLink("preload", PRODUCT_IMAGE, {
  as: "image",
  fetchpriority: "high"
});

// Non-blocking font loading
addLink("preconnect", "https://fonts.googleapis.com");
addLink("preconnect", "https://fonts.gstatic.com", {
  crossorigin: ""
});
const fonts = addLink("stylesheet", "https://fonts.googleapis.com/css2?family=Archivo:wght@700;800&family=Inter:wght@400;500;600;700&display=swap", {
  media: "print"
});
fonts.onload = () => {
  fonts.media = "all";
};
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-221" data-mp="3ru08yom55um2" />);
}